<template>
    <form method="post" v-on:submit.prevent="submit">

        <BasicInputs
            :loading="loading"
            :form-data="formData"
        ></BasicInputs>

        <fieldset :disabled="loading">

            <NumberOfGuests
                :loading="loading"
                :form-data="formData"
                :max-available-places="maxAvailablePlaces"
            >
                {{ $t('booking.inputs.numberOfGuests.labelEnquiry') }}
            </NumberOfGuests>

            <div class="mb-3">
                <label for="requested_single_rooms">
                    {{ $t("booking.inputs.requested_single_rooms.label") }}:
                </label>

                <input type="number" class="form-control"
                       name="requested_single_rooms"
                       id="requested_single_rooms"
                       v-model="formData.requested_single_rooms"
                       :min="minFreePlaces"
                       :max="formData.number_of_guests"
                       required>
            </div>

        </fieldset>

        <fieldset :disabled="loading">
            <div class="mb-3">
                <label for="note">
                    {{ $t("booking.inputs.question.label") }}:
                </label>

                <textarea class="form-control"
                          name="note"
                          id="note"
                          v-model="formData.note"
                          maxlength="2000"
                          :placeholder="$t('booking.inputs.question.placeholder')"
                          rows="4"
                ></textarea>
            </div>
        </fieldset>

        <MailchimpSubscription
            v-if="mailchimp"
            :loading="loading"
            :form-data="formData"
        ></MailchimpSubscription>

        <div class="mb-3 pb-0 mt-3 text-center">
            <button type="submit" class="btn btn-block btn-primary" :disabled="loading">
                {{ $t("booking.enquiry") }}
            </button>
        </div>

    </form>
</template>

<script>
import BasicInputs from "./inputFieldsets/BasicInputs";
import NumberOfGuests from "./inputFieldsets/NumberOfGuests";
import MailchimpSubscription from "./inputFieldsets/MailchimpSubscription";
import * as Ladda from "ladda";
import axios from "axios";

export default {
    props: {
        storeUrl: {
            required: true,
            type: String,
        },
        maxAvailablePlaces: {
            required: true,
            type: Number,
        },
        mailchimp: {
            type: Boolean,
        },
    },
    components: {
        BasicInputs,
        NumberOfGuests,
        MailchimpSubscription,
    },
    data() {
        return {
            loading: false,
            submitButton: null,

            formData: {

                first_name: '',
                last_name: '',
                email: '',
                phone: '',

                number_of_guests: '',
                requested_single_rooms: 0,

                newsletter_sign_up: false,
            },
        }
    },
    mounted() {
        this.submitButton = Ladda.create(this.$el.querySelector("button[type='submit']"));

        this.$captchaInit();
    },
    computed:{
        minFreePlaces() {
            return this.formData.number_of_guests % 2 === 0 ? 0 : 1;
        },
    },
    methods: {

        async submit() {
            this.loading = true;
            this.submitButton.start();

            let data = Object.assign(this.formData, {
                'g-recaptcha-response': await this.$captcha('gastrotour_enquiry'),
            });

            axios.post(this.storeUrl, data)
                .then(({data}) => {

                    if (data.redirect) {
                        window.location.replace(data.redirect);
                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.submitButton.stop();
                    this.$noty.ajaxError(error);
                });
        },

    },
}
</script>

<style scoped>

</style>
